import * as fabric from 'office-ui-fabric-react';
import { FC, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import * as api from '../../../api/generated';
import { KendoLoading } from '../../../components';
import { IWindowComponentProps } from '../../../components/windows/WindowContext';
import * as enums from '../../../enums';
import { QueuePriority } from '../../../enums';
import { transparentButton } from '../Helpers';
import { ITicket } from '../model';
import { CustomDropList } from './CustomDropList';

interface ISendToQueueModalProps {
    assignedTicket: ITicket;
    sendTicketToAnotherQueue(ticketId: number, queueId: number, serviceId: number | null, priority?: enums.QueuePriority): void;
}

const priorities = [
    { key: enums.queuePriority.Front, text: enums.queuePriority.format(enums.queuePriority.Front) },
    { key: enums.queuePriority.Back, text: enums.queuePriority.format(enums.queuePriority.Back) }
];

const SendToQueueModalWindow: FC<IWindowComponentProps<ISendToQueueModalProps>> = (props) => {
    const {
        componentProps: { assignedTicket, sendTicketToAnotherQueue },
        onClose
    } = props;

    const [isLoading, setIsLoading] = useState(false);
    const [selectedQueue, setSelectedQueue] = useState<number>();
    const [selectedService, setSelectedService] = useState<number>();
    const [selectedPriority, setSelectedPriority] = useState<QueuePriority>(priorities[0].key);

    const [queues, setQueues] = useState<{ id: number; name: string | null }[]>([]);
    const [services, setServices] = useState([{}]);

    useEffect(() => {
        const loadQueues = async () => {
            setQueues(await api.queueManagement.getQueuesByService(assignedTicket!.terminalServiceId!));
            setSelectedService(undefined);
        };

        if (assignedTicket != null) {
            loadQueues();
        }
    }, [assignedTicket?.terminalServiceId]);

    const loadServices = async (queueId: number) => {
        if (assignedTicket) {
            setSelectedQueue(queueId);
            const serv = await api.queueManagement.getServicesByQueue(queueId);
            setServices(
                serv.map((x) => {
                    return { key: x.id, text: x.name };
                })
            );
        }
    };

    const sendTicketToQueue = async (): Promise<void> => {
        try {
            sendTicketToAnotherQueue(assignedTicket.id, selectedQueue!, selectedService!, selectedPriority!);
        } catch (e) {
            toast.error('Klaida. Kreiptis i administratorių..');
        } finally {
            setIsLoading(false);
            onClose();
        }
    };

    const selectQueue = (queue: any) => {
        loadServices(queue.id);
    };

    const closeModal = (): void => {
        onClose();
    };

    return (
        <>
            {isLoading ? (
                <KendoLoading />
            ) : (
                <>
                    <div
                        style={{
                            marginTop: '3vw',
                            marginBottom: '1vw',
                            marginLeft: '5vw',
                            marginRight: '5vw',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'stretch'
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                marginBottom: '1vw',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                            }}
                        >
                            <fabric.Text>Pasirinkite padalinį/eilę</fabric.Text>
                            <CustomDropList items={queues} placeholder={'Pasirinkite padalinį/eilę'} selectItem={selectQueue}></CustomDropList>
                        </div>
                        {services.length && (
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    marginBottom: '1vw',
                                    justifyContent: 'space-between',
                                    alignItems: 'center'
                                }}
                            >
                                <fabric.Text>Pasirinkite paslaugą</fabric.Text>

                                <fabric.Dropdown
                                    className={'dropdownColor'}
                                    placeholder="Pasirinkite paslaugą"
                                    disabled={!selectedQueue}
                                    onChange={(e, item) => {
                                        setSelectedService(item!.key as number);
                                    }}
                                    options={services as fabric.IDropdownOption[]}
                                    styles={{
                                        root: {
                                            justifyContent: 'center',
                                            maxWidth: 250,
                                            width: 250,
                                            minWidth: 160
                                        }
                                    }}
                                />
                            </div>
                        )}
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                marginBottom: '1vw',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                            }}
                        >
                            <fabric.Text styles={{ root: { marginRight: '1vw' } }}>Siųsti į</fabric.Text>

                            <fabric.Dropdown
                                className={'dropdownColor'}
                                placeholder="Pasirinkite pirmenybę"
                                onChange={(e, item) => setSelectedPriority(item!.key as QueuePriority)}
                                options={priorities as fabric.IDropdownOption[]}
                                selectedKey={selectedPriority}
                                styles={{
                                    root: {
                                        justifyContent: 'center',
                                        maxWidth: 250,
                                        width: 250,
                                        minWidth: 160
                                    }
                                }}
                            />
                        </div>
                    </div>

                    <fabric.StackItem className="k-form-buttons">
                        <fabric.PrimaryButton
                            styles={transparentButton}
                            disabled={!selectedQueue}
                            onClick={() => sendTicketToQueue()}
                            text="Siųsti"
                        />
                        <fabric.PrimaryButton styles={transparentButton} onClick={() => closeModal()} text="Atšaukti" />
                    </fabric.StackItem>
                </>
            )}
        </>
    );
};

export default SendToQueueModalWindow;
